var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1478 8.62525H18.2125C17.3661 1.04301 6.6309 1.04864 5.78744 8.62525H4.85205C4.56728 8.62525 4.33643 8.85611 4.33643 9.14087V12C4.33643 12.2848 4.56728 12.5157 4.85205 12.5157H5.82615L7.19949 23.5481C7.23165 23.8062 7.45102 24 7.71118 24H16.2887C16.5489 24 16.7682 23.8062 16.8004 23.5481L18.1737 12.5157H19.1478C19.4326 12.5157 19.6635 12.2848 19.6635 12V9.14087C19.6635 8.85606 19.4326 8.62525 19.1478 8.62525ZM11.9999 3.93814C14.6947 3.93814 16.9175 5.99768 17.1773 8.62525H6.82257C7.08235 5.99768 9.3052 3.93814 11.9999 3.93814ZM15.8333 22.9688H8.16661L6.86537 12.5157H17.1345L15.8333 22.9688ZM18.6322 11.4844H5.36767V9.6565H18.6322V11.4844Z",
    fill: "#25282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6782 9.65649L12.3468 11.4844H13.3948L13.7262 9.65649H12.6782Z",
    fill: "#FF8051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6328 4.65505C14.3286 4.4758 14.0047 4.32664 13.6652 4.21161L12.8651 8.62522H13.9131L14.6328 4.65505Z",
    fill: "#FF8051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3664 0.607686C15.4173 0.327467 15.2313 0.0591548 14.9511 0.00834231C14.6711 -0.0424233 14.4025 0.14353 14.3518 0.423749L13.8508 3.1874C14.1893 3.29287 14.5155 3.42656 14.8267 3.58551L15.3664 0.607686Z",
    fill: "#FF8051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6174 15.7732L13.2079 12.5157H12.1599L11.5694 15.7732H7.27087L7.39922 16.8044H16.6007L16.729 15.7732H12.6174Z",
    fill: "#FF8051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrink);
export default __webpack_public_path__ + "static/media/drink.e8b69bf1068c10c3784c04e02386e00c.svg";
export { ForwardRef as ReactComponent };